import { render, staticRenderFns } from "./ConsumeTypePage.vue?vue&type=template&id=689a17dc"
import script from "./ConsumeTypePage.vue?vue&type=script&lang=js"
export * from "./ConsumeTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports